"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTestRegistrarContract = getTestRegistrarContract;
exports.getReverseRegistrarContract = getReverseRegistrarContract;
exports.getENSContract = getENSContract;
exports.getENSEvent = getENSEvent;
exports.getLabelhash = getLabelhash;
exports.getNamehash = getNamehash;
exports.getNamehashWithLabelHash = getNamehashWithLabelHash;
exports.getResolverContract = getResolverContract;
exports.getDnsRegistrarContract = getDnsRegistrarContract;
exports.getFifsRegistrarContract = getFifsRegistrarContract;
Object.defineProperty(exports, "normalize", {
  enumerable: true,
  get: function get() {
    return _ethEnsNamehash.normalize;
  }
});
exports.getENS = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _has = _interopRequireDefault(require("lodash/has"));

var _ethers = require("ethers");

var _web = require("./web3");

var _ethEnsNamehash = require("eth-ens-namehash");

var _utils = require("./utils");

var _ENS = require("@ensdomains/ens/build/contracts/ENS.json");

var _ReverseRegistrar = require("@ensdomains/ens/build/contracts/ReverseRegistrar.json");

var _Resolver = require("@ensdomains/resolver/build/contracts/Resolver.json");

var _FIFSRegistrar = require("@ensdomains/ens/build/contracts/FIFSRegistrar.json");

var _TestRegistrar = require("@ensdomains/ens/build/contracts/TestRegistrar.json");

var _DNSRegistrar = require("@ensdomains/dnsregistrar/build/contracts/DNSRegistrar.json");

var contracts = {
  1: {
    registry: '0x314159265dd8dbb310642f98f50c066173c1259b'
  },
  3: {
    registry: '0x112234455c3a32fd11230c42e7bccd4a84e02010'
  },
  4: {
    registry: '0xe7410170f87102df0055eb195163a03b7f2bff4a'
  },
  5: {
    registry: '0x112234455c3a32fd11230c42e7bccd4a84e02010'
  }
};
var ENS;
var readENS;

function getNamehash(unsanitizedName) {
  return (0, _utils.namehash)(unsanitizedName);
}

function getNamehashWithLabelHash(_x, _x2) {
  return _getNamehashWithLabelHash.apply(this, arguments);
}

function _getNamehashWithLabelHash() {
  _getNamehashWithLabelHash = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee2(labelHash, nodeHash) {
    var node;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            node = _ethers.utils.keccak256(nodeHash + labelHash.slice(2));
            return _context2.abrupt("return", node.toString());

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getNamehashWithLabelHash.apply(this, arguments);
}

function getLabelhash(label) {
  return _ethers.utils.solidityKeccak256(['string'], [label]);
}

function getReverseRegistrarContract() {
  return _getReverseRegistrarContract.apply(this, arguments);
}

function _getReverseRegistrarContract() {
  _getReverseRegistrarContract = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee3() {
    var _ref4, ENS, signer, namehash, reverseRegistrarAddr, reverseRegistrar;

    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return getENS();

          case 2:
            _ref4 = _context3.sent;
            ENS = _ref4.ENS;
            _context3.next = 6;
            return (0, _web.getSignerOrProvider)();

          case 6:
            signer = _context3.sent;
            namehash = getNamehash('addr.reverse');
            _context3.next = 10;
            return ENS.owner(namehash);

          case 10:
            reverseRegistrarAddr = _context3.sent;
            reverseRegistrar = new _ethers.Contract(reverseRegistrarAddr, _ReverseRegistrar.abi, signer);
            return _context3.abrupt("return", {
              reverseRegistrar: reverseRegistrar
            });

          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getReverseRegistrarContract.apply(this, arguments);
}

function getResolverContract(_x3) {
  return _getResolverContract.apply(this, arguments);
}

function _getResolverContract() {
  _getResolverContract = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee4(addr) {
    var signer, Resolver;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return (0, _web.getSignerOrProvider)();

          case 2:
            signer = _context4.sent;
            Resolver = new _ethers.Contract(addr, _Resolver.abi, signer);
            return _context4.abrupt("return", {
              Resolver: Resolver
            });

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getResolverContract.apply(this, arguments);
}

function getENSContract() {
  return _getENSContract.apply(this, arguments);
}

function _getENSContract() {
  _getENSContract = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee5() {
    var networkId, signer, ENS;
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return (0, _web.getNetworkId)();

          case 2:
            networkId = _context5.sent;
            _context5.next = 5;
            return (0, _web.getSignerOrProvider)();

          case 5:
            signer = _context5.sent;
            ENS = new _ethers.Contract(contracts[networkId].registry, _ENS.abi, signer);
            return _context5.abrupt("return", {
              readENS: ENS,
              ENS: ENS
            });

          case 8:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _getENSContract.apply(this, arguments);
}

function getFifsRegistrarContract() {
  return _getFifsRegistrarContract.apply(this, arguments);
}

function _getFifsRegistrarContract() {
  _getFifsRegistrarContract = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee6() {
    var _ref5, ENS, web3, fifsRegistrarAddr;

    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return getENS();

          case 2:
            _ref5 = _context6.sent;
            ENS = _ref5.ENS;
            web3 = _ref5.web3;
            _context6.next = 7;
            return ENS.owner('test');

          case 7:
            fifsRegistrarAddr = _context6.sent;
            return _context6.abrupt("return", {
              registrar: new _ethers.Contract(_FIFSRegistrar.abi, fifsRegistrarAddr),
              web3: web3
            });

          case 9:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _getFifsRegistrarContract.apply(this, arguments);
}

function getTestRegistrarContract() {
  return _getTestRegistrarContract.apply(this, arguments);
}

function _getTestRegistrarContract() {
  _getTestRegistrarContract = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee7() {
    var _ref6, ENS, signerOrProvider, namehash, testRegistrarAddr, registrar;

    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return getENS();

          case 2:
            _ref6 = _context7.sent;
            ENS = _ref6.ENS;
            _context7.next = 6;
            return (0, _web.getSignerOrProvider)();

          case 6:
            signerOrProvider = _context7.sent;
            namehash = getNamehash('test');
            _context7.next = 10;
            return ENS.owner(namehash);

          case 10:
            testRegistrarAddr = _context7.sent;
            registrar = new _ethers.Contract(testRegistrarAddr, _TestRegistrar.abi, signerOrProvider);
            return _context7.abrupt("return", {
              registrar: registrar
            });

          case 13:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _getTestRegistrarContract.apply(this, arguments);
}

var getENS =
/*#__PURE__*/
function () {
  var _ref = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee(ensAddress) {
    var networkId, hasRegistry, _ref2, ENSContract, readENSContract;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _web.getNetworkId)();

          case 2:
            networkId = _context.sent; //TODO: remove

            if (process.env.REACT_APP_ENS_ADDRESS && networkId > 1000) {
              //Assuming public main/test networks have a networkId of less than 1000
              ensAddress = process.env.REACT_APP_ENS_ADDRESS;
            }

            hasRegistry = (0, _has["default"])(contracts[networkId], 'registry');

            if (ENS) {
              _context.next = 13;
              break;
            }

            if (!(!hasRegistry && !ensAddress)) {
              _context.next = 8;
              break;
            }

            throw new Error("Unsupported network ".concat(networkId));

          case 8:
            if (contracts[networkId]) {
              ensAddress = contracts[networkId].registry;
            }

            contracts[networkId] = {};
            contracts[networkId].registry = ensAddress;
            _context.next = 14;
            break;

          case 13:
            return _context.abrupt("return", {
              ENS: ENS,
              _ENS: ENS,
              readENS: readENS,
              _readENS: readENS
            });

          case 14:
            _context.next = 16;
            return getENSContract();

          case 16:
            _ref2 = _context.sent;
            ENSContract = _ref2.ENS;
            readENSContract = _ref2.readENS;
            ENS = ENSContract;
            readENS = readENSContract;
            return _context.abrupt("return", {
              ENS: ENSContract,
              _ENS: ENSContract,
              readENS: readENS,
              _readENS: readENS
            });

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getENS(_x4) {
    return _ref.apply(this, arguments);
  };
}();

exports.getENS = getENS;

function getENSEvent(_x5, _x6) {
  return _getENSEvent.apply(this, arguments);
}

function _getENSEvent() {
  _getENSEvent = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee8(event, _ref3) {
    var topics, fromBlock, provider, _ref7, ENS, ensInterface, Event, filter, logs, parsed;

    return _regenerator["default"].wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            topics = _ref3.topics, fromBlock = _ref3.fromBlock;
            _context8.next = 3;
            return (0, _web.getWeb3)();

          case 3:
            provider = _context8.sent;
            _context8.next = 6;
            return getENS();

          case 6:
            _ref7 = _context8.sent;
            ENS = _ref7.ENS;
            ensInterface = new _ethers.utils.Interface(_ENS.abi);
            Event = ENS.filters[event]();
            filter = {
              fromBlock: fromBlock,
              toBlock: 'latest',
              address: Event.address,
              topics: [].concat((0, _toConsumableArray2["default"])(Event.topics), (0, _toConsumableArray2["default"])(topics))
            };
            _context8.next = 13;
            return provider.getLogs(filter);

          case 13:
            logs = _context8.sent;
            parsed = logs.map(function (log) {
              var parsedLog = ensInterface.parseLog(log);
              return parsedLog;
            });
            return _context8.abrupt("return", parsed);

          case 16:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _getENSEvent.apply(this, arguments);
}

function getDnsRegistrarContract(_x7) {
  return _getDnsRegistrarContract.apply(this, arguments);
}

function _getDnsRegistrarContract() {
  _getDnsRegistrarContract = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee9(parentOwner) {
    var signer, registrar;
    return _regenerator["default"].wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return (0, _web.getSignerOrProvider)();

          case 2:
            signer = _context9.sent;
            registrar = new _ethers.Contract(parentOwner, _DNSRegistrar.abi, signer);
            return _context9.abrupt("return", {
              registrar: registrar,
              web3: web3
            });

          case 5:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _getDnsRegistrarContract.apply(this, arguments);
}